const ESC = 0x1b
const GS  = 0x1d

function escposInit()          { return new Uint8Array([ESC, 0x40]) }
function escposCut()           { return new Uint8Array([GS, 0x56, 0x41, 0x03]) }
function escposAlign(n)        { return new Uint8Array([ESC, 0x61, n]) }
function escposBold(on)        { return new Uint8Array([ESC, 0x45, on ? 1 : 0]) }
function escposFontSize(w, h)  { return new Uint8Array([GS, 0x21, ((w - 1) << 4) | (h - 1)]) }
function escposText(str)       { return new TextEncoder().encode(str) }
function escposNewline(n = 1)  { return new Uint8Array(n).fill(0x0a) }
function escposDivider()       { return escposText('--------------------------------\n') }

function encodeText(str)       { return new TextEncoder().encode(str) }

function sanitizeLabelText(str) {
    return String(str || '')
        .replace(/[“”]/g, '"')
        .replace(/[‘’]/g, "'")
        .replace(/["\\]/g, '')
        .replace(/[^\x20-\x7E]/g, ' ')
        .trim()
}

function splitLabelLines(str, max = 26) {
    const words = sanitizeLabelText(str).split(/\s+/).filter(Boolean)
    const lines = []
    let current = ''

    for (const word of words) {
        if (!current) {
            current = word
        } else if (`${current} ${word}`.length <= max) {
            current = `${current} ${word}`
        } else {
            lines.push(current)
            current = word
        }
    }
    if (current) lines.push(current)
    return lines.length ? lines : ['Item']
}

export function buildReceiptBytes(order, items, transaction, branchName, branchAddress, cashier) {
    const chunks = []
    const push = (arr) => chunks.push(arr)

    push(escposInit())
    push(escposAlign(1))
    push(escposBold(true))
    push(escposFontSize(2, 2))
    push(escposText('Coffee Gusto\n'))
    push(escposFontSize(1, 1))
    push(escposBold(false))
    if (branchAddress) push(escposText(`${branchAddress}\n`))
    push(escposAlign())
    push(escposNewline(1))
    push(escposText(`Receipt #${(order.receipt_number ?? '').toString().padStart(6, '0')}\n`))
    push(escposText(`#${order.reference_number}\n`))
    push(escposText(`${new Date(order.created_at).toLocaleString('en-PH', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })}\n`))
    if (cashier) push(escposText(`Cashier: ${cashier}\n`))
    const fulfillMap = { dine_in: 'Dine-In', takeout: 'Takeout', pickup: 'Pickup', delivery: 'Delivery' }
    push(escposText(`${fulfillMap[order.fulfillment_type] || order.fulfillment_type || ''}\n`))
    push(escposText(`${order.order_source === 'pos' ? 'POS' : 'Mobile App'}\n`))
    push(escposDivider())
    push(escposAlign(1))
    push(escposText('* REPRINT ONLY *\n'))
    push(escposDivider())
    push(escposAlign(0))

    let totalQty = 0
    for (const item of items) {
        const qty = parseInt(item.quantity, 10) || 0
        const unitPrice = parseFloat(item.item_price || 0)
        const lineTotal = (unitPrice * qty).toFixed(2)
        totalQty += qty
        const name = `${item.menu_items?.name || 'Item'}`
        const price = `${lineTotal}`
        const pad = Math.max(1, 32 - name.length - price.length)
        push(escposText(`${name}${' '.repeat(pad)}${price}\n`))
        push(escposText(`  @P${unitPrice.toFixed(2)} x ${qty}\n`))
        if (item.order_item_variants?.length > 0)
            push(escposText(`  ${item.order_item_variants.map(v => v.item_variants?.variant_name).join(', ')}\n`))
        if (item.order_item_modifiers?.length > 0)
            push(escposText(`  +${item.order_item_modifiers.map(m => m.item_modifiers?.modifier_name).join(', ')}\n`))
    }

    push(escposDivider())

    const subtotalLine = (label, val) => {
        const v = `P${parseFloat(val || 0).toFixed(2)}`
        const pad = Math.max(1, 32 - label.length - v.length)
        push(escposText(`${label}${' '.repeat(pad)}${v}\n`))
    }

    subtotalLine('Subtotal', order.subtotal)
    if (parseFloat(order.discount || 0) > 0) subtotalLine('Discount', `-${parseFloat(order.discount).toFixed(2)}`)
    push(escposBold(true))
    subtotalLine('TOTAL', order.final_amount)
    push(escposBold(false))
    push(escposDivider())
    const itemText = `${totalQty} `
    const pad = Math.max(1, 32 - 'Total QTY'.length - itemText.length)
    push(escposText(`Total QTY${' '.repeat(pad)}${itemText}\n`))

    if (transaction) {
        push(escposDivider())
        push(escposAlign(0))
        const paymentLabels = {
            cash: 'Cash',
            gcash: 'GCash',
            card: 'Card',
            managers_pullout: "Manager's Pull-Out",
            marketing_pullout: 'Marketing Pull-Out',
        }
        const paymentLabel = paymentLabels[transaction.payment_method] || transaction.payment_method?.toUpperCase() || ''
        push(escposText(`Payment: ${paymentLabel}\n`))
        
        // push(escposText(`Status:  ${transaction.status || ''}\n`))
    }

    push(escposDivider())
    push(escposAlign(1))
    push(escposNewline(1))
    push(escposText('Thank you for visiting!\n'))
    // push(escposText(`${branchName || 'Coffee Gusto'}!\n`))
    push(escposNewline())
    push(escposAlign(1))
    push(escposText('NOT VALID FOR CLAIM OF INPUT TAX\n'))
    push(escposNewline(3))
    push(escposCut())


    const total = chunks.reduce((s, c) => s + c.length, 0)
    const result = new Uint8Array(total)
    let offset = 0
    for (const c of chunks) { result.set(c, offset); offset += c.length }
    return result
}

export function buildStickerBytes(item, order) {
    const chunks = []
    const push = (arr) => chunks.push(arr)
    const fulfillMap = { dine_in: 'Dine-In', takeout: 'Takeout', pickup: 'Pickup', delivery: 'Delivery' }

    push(escposInit())
    push(escposAlign(0))
    push(escposBold(true))
    push(escposFontSize(1, 2))
    push(escposText(`${item.menu_items?.name || 'Item'}\n`))
    push(escposFontSize(1, 1))
    push(escposBold(false))
    if (item.order_item_variants?.length > 0)
        push(escposText(`${item.order_item_variants.map(v => v.item_variants?.variant_name).join(' · ')}\n`))
    if (item.order_item_modifiers?.length > 0)
        push(escposText(`+${item.order_item_modifiers.map(m => m.item_modifiers?.modifier_name).join(', ')}\n`))
    push(escposText(`#${order.reference_number} · ${fulfillMap[order.fulfillment_type] || ''}\n`))
    push(escposNewline(2))
    push(escposCut())

    const total = chunks.reduce((s, c) => s + c.length, 0)
    const result = new Uint8Array(total)
    let offset = 0
    for (const c of chunks) { result.set(c, offset); offset += c.length }
    return result
}

export function buildStickerTsplBytes(item, order) {
    const fulfillMap = { dine_in: 'Dine-In', takeout: 'Takeout', pickup: 'Pickup', delivery: 'Delivery' }
    const nameLines = splitLabelLines(item.menu_items?.name || 'Item', 22).slice(0, 2)
    const variantText = item.order_item_variants?.length > 0
        ? item.order_item_variants.map(v => v.item_variants?.variant_name).filter(Boolean).join(', ')
        : ''
    const modifierText = item.order_item_modifiers?.length > 0
        ? `+${item.order_item_modifiers.map(m => m.item_modifiers?.modifier_name).filter(Boolean).join(', ')}`
        : ''
    const meta = `#${order.reference_number || ''} ${fulfillMap[order.fulfillment_type] || ''}`

    const lines = [
        'SIZE 50 mm,30 mm',
        'GAP 2 mm,0 mm',
        'DIRECTION 1',
        'REFERENCE 0,0',
        'CLS',
    ]

    let y = 24
    nameLines.forEach((line, idx) => {
        lines.push(`TEXT 24,${y + (idx * 34)},"0",0,2,2,"${sanitizeLabelText(line)}"`)
    })
    y += nameLines.length * 34

    if (variantText) {
        lines.push(`TEXT 24,${y + 6},"0",0,1,1,"${sanitizeLabelText(variantText).slice(0, 34)}"`)
        y += 28
    }
    if (modifierText) {
        lines.push(`TEXT 24,${y + 6},"0",0,1,1,"${sanitizeLabelText(modifierText).slice(0, 34)}"`)
        y += 28
    }
    lines.push(`TEXT 24,${y + 10},"0",0,1,1,"${sanitizeLabelText(meta).slice(0, 34)}"`)
    lines.push('PRINT 1,1')

    return encodeText(`${lines.join('\r\n')}\r\n`)
}

// ── End-of-Day Z-Reading (BIR-style layout) ────────────────────────────
const EOD_W = 32
const eodLine = (ch = '-') => escposText(ch.repeat(EOD_W) + '\n')

function eodMoney(v) {
    const n = Number(v || 0)
    const s = `P${Math.abs(n).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    return n < 0 ? `-${s}` : s
}

function eodRow(label, value) {
    const pad = Math.max(1, EOD_W - label.length - value.length)
    return escposText(`${label}${' '.repeat(pad)}${value}\n`)
}

export function buildEodReportBytes(d) {
    const chunks = []
    const push = (a) => chunks.push(a)
    const section = (title) => {
        push(escposNewline(1))
        push(escposBold(true)); push(escposText(`${title}\n`)); push(escposBold(false))
        push(eodLine('-'))
    }

    push(escposInit())

    // Header
    push(escposAlign(1))
    push(escposBold(true))
    push(eodLine('='))
    push(escposFontSize(2, 2)); push(escposText('COFFEE GUSTO\n')); push(escposFontSize(1, 1))
    push(escposText(`BRANCH: ${d.branchName || '-'}\n`))
    push(escposText('END OF DAY REPORT\n'))
    push(escposBold(false))
    push(eodLine('='))
    push(escposAlign(0))
    // push(eodRow('Business Date :', d.businessDate).slice ? escposText(`Business Date : ${d.businessDate}\n`) : null)
    push(escposText(`Business Date : ${d.businessDate}\n`))
    push(escposText(`Generated     : ${d.generatedAt}\n`))
    push(escposText(`Z-Counter     : ${String(d.zCounter).padStart(6, '0')}\n`))
    push(eodLine('-'))

    // Sales summary
    section('SALES SUMMARY')
    push(eodRow('Total Transactions', String(d.totalTransactions)))
    push(eodRow('Gross Sales', eodMoney(d.grossSales)))
    push(eodRow('Discounts', eodMoney(d.discounts)))
    push(eodRow('Refunds', eodMoney(d.refunds)))
    push(eodRow('Voids', eodMoney(d.voids)))
    push(escposBold(true)); push(eodRow('Net Sales', eodMoney(d.netSales))); push(escposBold(false))

    // Sales breakdown
    section('SALES BREAKDOWN')
    push(eodRow('VATable Sales', eodMoney(d.vatableSales)))
    push(eodRow('VAT Amount', eodMoney(d.vatAmount)))
    push(eodRow('VAT-Exempt Sales', eodMoney(d.vatExempt)))
    push(eodRow('Zero-Rated Sales', eodMoney(d.zeroRated)))

    // Payment summary
    section('PAYMENT SUMMARY')
    if (d.payments.length === 0) push(escposText('No payments recorded\n'))
    for (const p of d.payments) push(eodRow(p.label, eodMoney(p.amount)))
    push(eodLine('-'))
    push(escposBold(true)); push(eodRow('TOTAL PAYMENTS', eodMoney(d.totalPayments))); push(escposBold(false))

    // Order summary
    section('ORDER SUMMARY')
    push(eodRow('Dine-In', String(d.orderTypes.dine_in)))
    push(eodRow('Takeout', String(d.orderTypes.takeout)))
    push(eodRow('Pickup', String(d.orderTypes.pickup)))
    push(eodRow('Delivery', String(d.orderTypes.delivery)))
    push(eodLine('-'))
    push(escposBold(true)); push(eodRow('TOTAL', String(d.totalTransactions))); push(escposBold(false))

    // Cash drawer
    section('CASH DRAWER')
    if (!d.drawer) {
        push(escposText('No drawer session today\n'))
    } else {
        push(eodRow('Opening Cash', eodMoney(d.drawer.opening)))
        push(eodRow('Cash Sales', eodMoney(d.drawer.cashSales)))
        push(eodRow('Cash In', eodMoney(d.drawer.cashIn)))
        push(eodRow('Cash Out', eodMoney(d.drawer.cashOut)))
        push(eodRow('Expected Cash', eodMoney(d.drawer.expected)))
        push(escposNewline(1))
        push(eodRow('Actual Cash', d.drawer.actual == null ? '(drawer open)' : eodMoney(d.drawer.actual)))
        push(eodRow('Variance', d.drawer.variance == null ? '-' : eodMoney(d.drawer.variance)))
    }

    // Cashier activity
    section('CASHIER ACTIVITY')
    if (d.cashiers.length === 0) push(escposText('No cashier activity\n'))
    for (const c of d.cashiers) push(eodRow(c.name.slice(0, 26), String(c.count)))

    // Accumulated sales
    push(escposNewline(1))
    push(eodLine('-'))
    push(escposText('Beginning Accumulated\n'))
    push(eodRow('Sales', eodMoney(d.beginningAccumulated)))
    push(escposNewline(1))
    push(escposText('Ending Accumulated\n'))
    push(eodRow('Sales', eodMoney(d.endingAccumulated)))

    // Footer
    push(escposNewline(1))
    push(eodLine('-'))
    push(escposAlign(1))
    push(escposBold(true))
    push(escposText('END OF DAY\n'))
    push(escposText('Z-READING\n'))
    push(escposBold(false))
    push(eodLine('-'))
    push(escposNewline(3))
    push(escposCut())

    const total = chunks.reduce((s, c) => s + c.length, 0)
    const result = new Uint8Array(total)
    let offset = 0
    for (const c of chunks) { result.set(c, offset); offset += c.length }
    return result
}
